import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { priceService as service } from '@services/priceService';

export const getPriceService = () => {
  return service;
};

export function usePrices() {
  const queryClient = useQueryClient();

  // Use React Query for loading state and cache management
  const query = useQuery({
    queryKey: ['prices', 'all'],
    queryFn: async () => {
      await service.bootstrap();
      return service.getPricesSnapshot();
    },
    staleTime: 1000,
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    // Always refetch on mount to ensure price service is bootstrapped
    // (localStorage persistence may restore cache without running bootstrap)
    refetchOnMount: 'always',
  });

  // Subscribe to real-time price updates and sync to React Query cache
  useEffect(() => {
    if (query.isLoading || query.isError) {
      return;
    }
    const unsubscribe = service.subscribe(newPrices => {
      // Update React Query cache with new data
      queryClient.setQueryData(['prices', 'all'], newPrices);
    });
    return () => {
      unsubscribe();
    };
  }, [queryClient, query.isLoading, query.isError]);

  return query;
}
